// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26spA","left":"styles_left__3HG8c"};